import { createActionGroup, props } from "@ngrx/store";
import { ItemCategory } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export const DataCategoriesActions = createActionGroup({
    source: "Data / Categories",
    events: {
        "Load": props<{ companyId: string }>(),
        "Load Success": props<{ categories: ItemCategory[] }>(),
        "Load Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
